module.exports = __webpack_public_path__ + "static/media/silueta_paula.e58600f6.png";